import { memo, useEffect, useCallback } from 'react';
import { withRouter } from 'react-router-dom';
import { cdnLogin } from '../../../../conf';

const Version = withRouter(({ history, currentVersion, setVersion }) => {

    const cleanStorage = useCallback(() => {
        localStorage.clear();
        sessionStorage.clear();
    }, []);

    const versionControl = useCallback(() => {
        
        if (currentVersion && process.env.REACT_APP_VERSION !== currentVersion) {
            setVersion(process.env.REACT_APP_VERSION);
            cleanStorage();
            window.location.href = cdnLogin;
        }
    }, [currentVersion, setVersion, cleanStorage]);

    useEffect(() => { versionControl(); }, [versionControl]);

    return (null);
});

export default memo(Version);